import { render, staticRenderFns } from "./TagEntry.vue?vue&type=template&id=6b463dac&scoped=true"
import script from "./TagEntry.vue?vue&type=script&lang=ts"
export * from "./TagEntry.vue?vue&type=script&lang=ts"
import style0 from "./TagEntry.vue?vue&type=style&index=0&id=6b463dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b463dac",
  null
  
)

export default component.exports